import { useTheme } from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

interface ISectionTitle {
  title: string;
  children?: React.ReactNode;
  mt?: number | string;
}

const SectionTitle = ({ title, children, mt }: ISectionTitle) => {
  const { palette } = useTheme();

  return (
    <Grid size={12} display="flex" alignItems="center" gap={1} mb={4} mt={mt} textAlign="start">
      {children}
      <Typography variant="h5" color={palette.secondary.main}>
        {title}
      </Typography>
    </Grid>
  );
};

export default SectionTitle;
